import axios from "axios"

const s3AxiosInstance = axios.create()

export default s3AxiosInstance
